jQuery( document ).ready( function( $ ) {
    console.log('base menu loaded');
    /**
     * Handle menus
     */

    // Desktop


    // $('.menu-item-has-children').on('mouseenter', function() {
    //     // console.log('open submenu', this);
    //     openSubmenu(this);
    //     // closeOtherSubmenus(this);
    //     // $(this).find('> ul').stop(true, true).fadeIn(200);
    //     // $(this).addClass('open');
    // }); 
    const mainMenu = $('.main-menu');
    const menuItems = mainMenu.find('.menu-item-has-children > a');

    mainMenu.find('.menu-item-has-children > a').on('click', function(e) {
        e.preventDefault();
        handleMenu(this);
    });

    mainMenu.find('.menu-item-has-children > a').on('mouseenter', function(e) {
        handleMenu(this);
    });

    $('.header-main').on('mouseleave', function(e) {                        
        for(let menuItem of menuItems){
            closeSubmenu(menuItem);
        }
    });

    function handleMenu(element) {
        for(let menuItem of menuItems){
            if(menuItem == element){
                const isOpen = $(element).parent().hasClass('open');
                if (isOpen) {            
                    closeSubmenu(element);
                    mainMenu.removeClass('submenu-open');
                } else {
                    mainMenu.addClass('submenu-open');
                    openSubmenu(element);
                }
            } else {
                closeSubmenu(menuItem);

            }
        }        
    }
    
    function openSubmenu(element) {        
        $(element).siblings('ul.sub-menu').stop(true, true).fadeIn(200);        
        $(element).parent().addClass('open');
        // $(element).addClass('open');
    }

    function closeSubmenu(element) {
        $(element).siblings('ul.sub-menu').stop(true, true).fadeOut(200);
        $(element).parent().removeClass('open');
        // $(element).removeClass('open');
    }

    function closeOtherSubmenus(element) {
        $('.menu-item-has-children').each(function() {
            if (this !== element) {
                closeSubmenu(this);
            }
        });
    }



    // Mobile: toggle submenu on click (scoped to mobile container).
    // Visibility is driven by the `.open` class via CSS (see _mobile-menu.scss),
    // so we only toggle the class here.
    $('#mobile-menu-container .menu-item-has-children > a').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('open');
    });

    // Desktop: hover-based submenu with close delay to allow diagonal mouse movement
    // const mainMenuItems = document.querySelectorAll('#main-menu > li.menu-item-has-children');

    // mainMenuItems.forEach(function(item) {
    //     let closeTimeout;

    //     function openSubmenu() {
    //         clearTimeout(closeTimeout);
    //         mainMenuItems.forEach(function(other) {
    //             if (other !== item) other.classList.remove('submenu-open');
    //         });
    //         item.classList.add('submenu-open');
    //     }

    //     function scheduleClose() {
    //         closeTimeout = setTimeout(function() {
    //             item.classList.remove('submenu-open');
    //         }, 200);
    //     }

    //     item.addEventListener('mouseenter', openSubmenu);
    //     item.addEventListener('mouseleave', scheduleClose);
    // });

    // // Close desktop submenus when clicking outside the menu
    // document.addEventListener('click', function(e) {
    //     if (!e.target.closest('#main-menu')) {
    //         mainMenuItems.forEach(function(item) {
    //             item.classList.remove('submenu-open');
    //         });
    //     }
    // });

    // // Close mobile submenus when clicking outside an open submenu
    // document.addEventListener('click', function(e) {
    //     if (!e.target.closest('#mobile-menu-container .menu-item-has-children')) {
    //         $('#mobile-menu-container .menu-item-has-children').each(function() {
    //             $(this).find('> ul').stop(true, true).slideUp(200);
    //             $(this).removeClass('open');
    //         });
    //     }
    // });
} );